module.exports = __webpack_public_path__ + "img/isbar_ed.88260419.jpg";